import React, { useState, useEffect } from "react";
import reportAPI from "../../../../api/report";
import { FilterYearType } from "../common/ReportFilters";
import { ButtonExcel } from "../../../../utils/buttonLoadExcel";
import {
  FLEXDROPDOWN,
  SCREENIPAD,
  STYLEBODY,
  STYLEHEAD,
  TABLE,
  LEFTTABLE,
  THTABLE,
  RIGHTTABLE,
  TRTABLE,
  TXCENTER,
} from "../../../../utils/useStyle";
import { ExcelAttemptByDoc } from "../../functions/Report.ExportAttemptByDoc";

const ReportAttemptByDoctor = ({ userDept }) => {
  const [loading, setLoading] = useState(false);
  const [year, setYear] = useState({
    label: "ทุกปี",
    value: "ALL",
  });
  const [type, setType] = useState({
    label: "-",
    value: "NONE",
  });

  const [data, setData] = useState([]);

  useEffect(() => {
    // Use backend API instead of frontend processing
    const fetchData = async () => {
      try {
        const response = await reportAPI.getAttemptByDoctorReport({
          year: String(year?.value),
          type: String(type?.value),
          user_department: userDept,
        });
        if (response?.success) {
          setData(response.data);
        }
      } catch (error) {
        console.error("Error fetching attempt by doctor report:", error);
      }
    };
    fetchData();
  }, [year, type, userDept]);

  const submitExcelData = data?.map((item) => {
    return {
      doctor: item?.doctor,
      countAttemps: item?.countSuccess + item?.countUnsuccess,
      countSuccess: item?.countSuccess,
      countSuccess_percent: (
        (item?.countSuccess * 100) /
        (item?.countSuccess + item?.countUnsuccess)
      ).toFixed(1),
      countUnsuccess: item?.countUnsuccess,
      countUnsuccess_percent: (
        (item?.countUnsuccess * 100) /
        (item?.countSuccess + item?.countUnsuccess)
      ).toFixed(1),
    };
  });

  return (
    <div className="my-20">
      <div className={SCREENIPAD}>
        <div className={STYLEHEAD}>
          attempt ทั้งหมด แยกตามแพทย์ผู้ใส่
          <div className={STYLEBODY}>
            ของปี {year?.label} ตามประเภทสาย {type?.label}
          </div>
        </div>
        <div className={FLEXDROPDOWN}>
          <FilterYearType
            year={year}
            setYear={setYear}
            type={type}
            setType={setType}
          />
          <ButtonExcel
            text={"DOWNLOAD EXCEL"}
            onClick={() => {
              ExcelAttemptByDoc(submitExcelData, year, type);
            }}
            loading={loading}
          />
        </div>
      </div>

      <table className={TABLE}>
        <thead>
          <tr>
            <th className={LEFTTABLE}>ลำดับที่</th>
            <th className={THTABLE}> ชื่อ </th>
            <th className={THTABLE}> attempt ทั้งหมด</th>
            <th className={THTABLE}> attempt ที่สำเร็จ</th>
            <th className={THTABLE}> % ที่สำเร็จ</th>
            <th className={THTABLE}> attempt ที่ Fail </th>
            <th className={RIGHTTABLE}> % ที่ Fail </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((item, index) => (
            <tr key={index} className={TRTABLE}>
              <th className={TXCENTER}> {index + 1}</th>
              <td className={TXCENTER}> {item?.doctor}</td>
              <td className={TXCENTER}>
                {" "}
                {item?.countSuccess + item?.countUnsuccess}
              </td>
              <td className={TXCENTER}> {item?.countSuccess}</td>
              <td className={TXCENTER}>
                {" "}
                {(
                  (item?.countSuccess * 100) /
                  (item?.countSuccess + item?.countUnsuccess)
                ).toFixed(1) + "%"}
              </td>
              <td className={TXCENTER}> {item?.countUnsuccess}</td>
              <td className={TXCENTER}>
                {" "}
                {(
                  (item?.countUnsuccess * 100) /
                  (item?.countSuccess + item?.countUnsuccess)
                ).toFixed(1) + "%"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ReportAttemptByDoctor;
